import React, { useState, useEffect, useRef } from "react";
import { Form, Button, Col, Container, Row, InputGroup } from "react-bootstrap";
import Select from "react-select";
import {
  ELECTRIC_PROVIDERS,
  CUSTOM_WELL_FORM_SELECT_STYLES,
  EMPTY,
} from "../../../configurations/Constants";
import { ENTER_VALID_GPM } from "../../../configurations/MessageConstants";

function IrrigationInfo(props) {
  const [validated, setValidated] = useState(false);
  const mounted = useRef(true);
  const nonElectricInput = useRef();
  const OtherIrrigationInput = useRef();

  useEffect(() => {
    if (mounted.current) {
      mounted.current = false;
    } else {
      nonElectricInput.current.focus();
    }
  }, [props.inputValues.nonElectric]);

  useEffect(() => {
    if (mounted.current) {
      mounted.current = false;
    } else {
      OtherIrrigationInput.current.focus();
    }
  }, [props.inputValues.OtherIrrigation]);

  const saveAndContinue = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === true) {
      event.preventDefault();
      props.nextStep();
    } else {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
  };

  const back = (e) => {
    e.preventDefault();
    props.prevStep();
  };

  return (
    <Container className="well-test-form-irrig-info">
      <br></br>
      <h3 className="mt-2">Irrigation Information</h3>
      <hr />
      <Form noValidate validated={validated} onSubmit={saveAndContinue}>
        <div className="well-test-form-body">
          <Row>
            <Form.Group as={Col} controlId="formElectricityProvider" md={4}>
              <Form.Label className="label">Electricity Provider</Form.Label>
              <Select
                name="electricityProvider"
                options={ELECTRIC_PROVIDERS}
                isClearable={true}
                className={
                  validated ? "well-test-form-validation-success" : EMPTY
                }
                styles={CUSTOM_WELL_FORM_SELECT_STYLES}
                onChange={props.handleElectricityProviderChange}
                value={props.inputValues.electricityProvider}
                placeholder="-- Select Provider --"
              />
            </Form.Group>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Label className="label required-field">
                Electric Power Unit
              </Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  value="Yes"
                  label="Yes"
                  name="isElectricPowerUnit"
                  id="Yes_isElectricPowerUnit"
                  required
                  onChange={props.handleChange}
                  checked={props.inputValues.isElectricPowerUnit === "Yes"}
                  className="gap-2"
                />
                <Form.Check
                  type="radio"
                  value="No"
                  label="No"
                  name="isElectricPowerUnit"
                  id="No_isElectricPowerUnit"
                  onChange={props.handleChange}
                  checked={props.inputValues.isElectricPowerUnit === "No"}
                  className="gap-2"
                />
              </div>
            </Col>
            <Col md={6}>
              <Form.Label className="label required-field">
                Non-Electric
              </Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  value="Diesel"
                  label="Diesel"
                  name="nonElectric"
                  disabled={
                    props.inputValues.isElectricPowerUnit === "No"
                      ? false
                      : true
                  }
                  required
                  id="Diesel"
                  onChange={props.handleChange}
                  checked={props.inputValues.nonElectric === "Diesel"}
                  className="gap-2"
                />
                <Form.Check
                  type="radio"
                  value="Propane"
                  label="Propane"
                  name="nonElectric"
                  id="Propane"
                  disabled={
                    props.inputValues.isElectricPowerUnit === "No"
                      ? false
                      : true
                  }
                  onChange={props.handleChange}
                  checked={props.inputValues.nonElectric === "Propane"}
                  className="gap-2"
                />
                <Form.Check
                  type="radio"
                  value="Natural Gas"
                  label="Natural Gas"
                  name="nonElectric"
                  id="Natural Gas"
                  disabled={
                    props.inputValues.isElectricPowerUnit === "No"
                      ? false
                      : true
                  }
                  onChange={props.handleChange}
                  checked={props.inputValues.nonElectric === "Natural Gas"}
                  className="gap-2"
                />
                <InputGroup as={Col} className="ps-0">
                  <Form.Check
                    type="radio"
                    value="Other"
                    label="Other"
                    name="nonElectric"
                    id="Other"
                    disabled={
                      props.inputValues.isElectricPowerUnit === "No"
                        ? false
                        : true
                    }
                    onChange={props.handleChange}
                    checked={props.inputValues.nonElectric === "Other"}
                    className="gap-2"
                  />

                  <Form.Control
                    md="5"
                    ref={nonElectricInput}
                    type="text"
                    autoComplete="off"
                    defaultValue={props.inputValues.otherNonElectric}
                    name="otherNonElectric"
                    onChange={props.handleChange}
                    placeholder="Enter type"
                    className={
                      props.inputValues.nonElectric === "Other"
                        ? "h-75 p-1 ms-2 "
                        : "d-none"
                    }
                  />
                </InputGroup>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Label className="label">
                Does unit have an hour meter?
              </Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  value="Yes"
                  label="Yes"
                  name="hasHourMeter"
                  id="Yes_hasHourMeter"
                  onChange={props.handleChange}
                  checked={props.inputValues.hasHourMeter === "Yes"}
                  className="gap-2"
                />
                <Form.Check
                  type="radio"
                  value="No"
                  label="No"
                  name="hasHourMeter"
                  id="No_hasHourMeter"
                  onChange={props.handleChange}
                  checked={props.inputValues.hasHourMeter === "No"}
                  className="gap-2"
                />
              </div>
            </Col>
            <Col md={6}>
              <Form.Label className="label">Does the meter work?</Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  value="Yes"
                  label="Yes"
                  name="doesMeterWork"
                  id="Yes_doesMeterWork"
                  onChange={props.handleChange}
                  checked={props.inputValues.doesMeterWork === "Yes"}
                  className="gap-2"
                />
                <Form.Check
                  type="radio"
                  value="No"
                  label="No"
                  name="doesMeterWork"
                  id="No_doesMeterWork"
                  onChange={props.handleChange}
                  checked={props.inputValues.doesMeterWork === "No"}
                  className="gap-2"
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Label className="label required-field">
                Irrigation Type
              </Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="checkbox"
                  value="Pivot"
                  label="Pivot"
                  name="pivotIrrigationType"
                  id="Pivot"
                  required={
                    props.inputValues.Pivot ||
                    props.inputValues.Flood ||
                    props.inputValues.PivotFlood ||
                    props.inputValues.OtherIrrigation
                      ? false
                      : true
                  }
                  onChange={props.handleCheckboxChange}
                  checked={props.inputValues.Pivot === true}
                  className="gap-2"
                />
                <Form.Check
                  type="checkbox"
                  value="Flood"
                  label="Flood"
                  name="floodIrrigationType"
                  id="Flood"
                  required={
                    props.inputValues.Pivot ||
                    props.inputValues.Flood ||
                    props.inputValues.PivotFlood ||
                    props.inputValues.OtherIrrigation
                      ? false
                      : true
                  }
                  onChange={props.handleCheckboxChange}
                  checked={props.inputValues.Flood === true}
                  className="gap-2"
                />
                <Form.Check
                  type="checkbox"
                  value="PivotFlood"
                  label="Pivot + Flood"
                  name="pivotFloodIrrigationType"
                  id="PivotFlood"
                  required={
                    props.inputValues.Pivot ||
                    props.inputValues.Flood ||
                    props.inputValues.PivotFlood ||
                    props.inputValues.OtherIrrigation
                      ? false
                      : true
                  }
                  onChange={props.handleCheckboxChange}
                  checked={props.inputValues.PivotFlood === true}
                  className="gap-2"
                />
                <InputGroup as={Col} className="ps-0">
                  <Form.Check
                    type="checkbox"
                    value="OtherIrrigation"
                    label="Other"
                    name="otherIrrigationType"
                    id="Other"
                    required={
                      props.inputValues.Pivot ||
                      props.inputValues.Flood ||
                      props.inputValues.PivotFlood ||
                      props.inputValues.OtherIrrigation
                        ? false
                        : true
                    }
                    onChange={props.handleCheckboxChange}
                    checked={props.inputValues.OtherIrrigation === true}
                    className="gap-2"
                  />

                  <Form.Control
                    ref={OtherIrrigationInput}
                    type="text"
                    autoComplete="off"
                    defaultValue={props.inputValues.otherIrrigationTypeName}
                    name="otherIrrigationTypeName"
                    onChange={props.handleChange}
                    placeholder="Enter type"
                    className={
                      props.inputValues.otherIrrigationType ===
                      "OtherIrrigation"
                        ? "h-75 p-1 ms-2 "
                        : "d-none"
                    }
                  />
                </InputGroup>
              </div>
            </Col>
            <Col md={6}>
              <Form.Label className="label required-field">End Gun</Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  value="Yes"
                  label="Yes"
                  name="endGun"
                  id="Yes_endGun"
                  required
                  onChange={props.handleChange}
                  checked={props.inputValues.endGun === "Yes"}
                  className="gap-2"
                />
                <Form.Check
                  type="radio"
                  value="No"
                  label="No"
                  name="endGun"
                  id="No_endGun"
                  onChange={props.handleChange}
                  checked={props.inputValues.endGun === "No"}
                  className="gap-2"
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Label className="label required-field">
                Swing Arm
              </Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  value="Yes"
                  label="Yes"
                  name="swingArm"
                  id="Yes_swingArm"
                  required
                  onChange={props.handleChange}
                  checked={props.inputValues.swingArm === "Yes"}
                  className="gap-2"
                />
                <Form.Check
                  type="radio"
                  value="No"
                  label="No"
                  name="swingArm"
                  id="No_swingArm"
                  onChange={props.handleChange}
                  checked={props.inputValues.swingArm === "No"}
                  className="gap-2"
                />
              </div>
            </Col>
            <Col md={4} className="mb-3">
              <Form.Label className="label">GPM of End Gun if known</Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                defaultValue={props.inputValues.endGunGpm}
                name="endGunGpm"
                onChange={props.handleChange}
                pattern="^([0-9]*[.])?[0-9]+"
              />
              <Form.Control.Feedback type="invalid">
                {ENTER_VALID_GPM}
              </Form.Control.Feedback>
            </Col>
          </Row>
        </div>
        <Button variant="primary" onClick={back}>
          Back
        </Button>{" "}
        <Button variant="primary" className="well-test-next-btn" type="submit">
          Next
        </Button>
      </Form>
    </Container>
  );
}

export default IrrigationInfo;
